/** @type {"mobile"} */
export const LAYOUT_MOBILE = "mobile";
/** @type {"desktop"} */
export const LAYOUT_DESKTOP = "desktop";
export const SYNCED_PROPS = "sync";
export const LAYOUTS = [LAYOUT_MOBILE, LAYOUT_DESKTOP];

/** @type {"mixed"} */
export const MIXED = "mixed";
/** @type {"isDeviation"} */
export const IS_DEVIATION = "isDeviation";
/** @type {"mixedSync"} */
export const MIXED_SYNC = "mixedSync";

export const GLOBAL_CODE_DATA_KEY = "globalCodeData";
export const GLOBAL_CODE_KEY = "globalCode";
export const APPLY_TO = "applyTo";
export const CANVAS_SET_DATA = "canvasSetData";
export const RECENT_PEXELS_PHOTOS_KEY = "recentPexelsPhotos";
export const INCLUDE_WITH_EXPORT = "includeWithExport";
export const EXCLUDE_FROM_GLOBAL_CODE = "excludeFromGlobalCode";

export const CUSTOM_CODE_LABEL = "label";
export const CUSTOM_CODE_HEAD_HTML = "headHTML";
export const CUSTOM_CODE_CSS = "CSS";
export const CUSTOM_CODE_TOP_BODY_HTML = "topBodyHTML";
export const CUSTOM_CODE_BOTTOM_BODY_HTML = "bottomBodyHTML";
